// import { Divider, Grid, Typography } from "@mui/material";
// import { useEffect, useState } from "react";
// import {
//   Control,
//   FieldErrors,
//   UseFormRegister,
//   UseFormReset,
//   UseFormSetValue,
// } from "react-hook-form";

// import { shallowEqual, useSelector } from "react-redux";
// import WSButton from "../../../Components/Button/WSButton";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSPhone from "../../../Components/Phone/WSPhone";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import clientconfig from "../../../Config/clientConfig.json";
// import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
// interface PrescriptionProps {
//   control?: Control<any>;
//   errors?: FieldErrors;
//   register: UseFormRegister<any>;
//   id: any;
//   reset: UseFormReset<any>;
//   noteId?: string;
//   setValue: UseFormSetValue<any>;
//   onCancel: () => void;
// }

// const TechnicianDrawer: React.FC<PrescriptionProps> = ({
//   control,
//   id,
//   register,
//   noteId,
//   reset,
//   setValue,
//   onCancel,
// }) => {
//   useEffect(() => {
//     return () => {
//       reset();
//     };
//   }, []);

//   return (
//     <Grid>
//       {
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12}>
//             <WSImageUpload
//               control={control}
//               id="image"
//               name="image"
//               label=""
//               rules={{ required: false }}
//             //   onChange={handleUploadChange}
//             //   imgUrl={imageUrl}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="name"
//               name="name"
//               rules={{ required: true }}
//               label="Name"
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <WSPhone
//               label="Phone Number"
//               rules={{ required: true }}
//               control={control}
//               id="phoneNumber"
//               {...register("phoneNumber")}
//               name="phoneNumber"
//               disabled
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="fullAddress"
//               name="fullAddress"
//               rules={{ required: true }}
//               label="Full Address"
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <WSDateField
//               id={"dob"}
//               name={"dob"}
//               label={"DOB"}
//               dateFormat="DD-MM-YYYY"
//               control={control}
//               isInGridFilter={false}
//               defaultValue={null}
//               rules={{ required: false }}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="qualification"
//               name="qualification"
//               rules={{ required: true }}
//               label="Qualification"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="experience"
//               name="experience"
//               rules={{ required: true }}
//               label="Experience"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="workingHours"
//               name="workingHours"
//               rules={{ required: true }}
//               label="Working Hours"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Typography>Documents & Verification</Typography>
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               Aadhar
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("aadhar")}
//               id="aadhar"
//               control={control}
//               isInGridFilter={false}
//               label=""
//               name="aadhar"
//               // options={clientconfig.mode.staticOptionData}
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               License
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("license")}
//               id="license"
//               control={control}
//               label=""
//               name="license"
//               // options={clientconfig.mode.staticOptionData}
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               Certification
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("certification")}
//               id="certification"
//               control={control}
//               label=""
//               name="certification"
//               // options={clientconfig.mode.staticOptionData}
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               Police Verification
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("policeVerification")}
//               id="policeVerification"
//               control={control}
//               label=""
//               name="policeVerification"
//               options={clientconfig.policeVerification.staticOptionData}
//             />
//           </Grid>
//         </Grid>
//       }
//     </Grid>
//   );
// };
// export default TechnicianDrawer;











// import { Divider, Grid, Typography } from "@mui/material";
// import { useEffect, useState } from "react";
// import {
//   Control,
//   FieldErrors,
//   UseFormRegister,
//   UseFormReset,
//   UseFormSetValue,
// } from "react-hook-form";

// import { shallowEqual, useSelector } from "react-redux";
// import WSButton from "../../../Components/Button/WSButton";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSPhone from "../../../Components/Phone/WSPhone";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import clientconfig from "../../../Config/clientConfig.json";
// import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
// interface PrescriptionProps {
//   control?: Control<any>;
//   errors?: FieldErrors;
//   register: UseFormRegister<any>;
//   id: any;
//   reset: UseFormReset<any>;
//   noteId?: string;
//   setValue: UseFormSetValue<any>;
//   onCancel: () => void;
// }

// const TechnicianDrawer: React.FC<PrescriptionProps> = ({
//   control,
//   id,
//   register,
//   noteId,
//   reset,
//   setValue,
//   onCancel,
// }) => {
//   useEffect(() => {
//     return () => {
//       reset();
//     };
//   }, []);

//   return (
//     <Grid>
//       {
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12}>
//             <WSImageUpload
//               control={control}
//               id="image"
//               name="image"
//               label=""
//               rules={{ required: false }}
//             //   onChange={handleUploadChange}
//             //   imgUrl={imageUrl}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="name"
//               name="name"
//               rules={{ required: true }}
//               label="Name"
//             />
//           </Grid>

          // <Grid item xs={12}>
          //   <WSPhone
          //     label="Phone Number"
          //     rules={{ required: true }}
          //     control={control}
          //     id="phoneNumber"
          //     {...register("phoneNumber")}
          //     name="phoneNumber"
          //     disabled
          //   />
          // </Grid>

//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="fullAddress"
//               name="fullAddress"
//               rules={{ required: true }}
//               label="Full Address"
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <WSDateField
//               id={"dob"}
//               name={"dob"}
//               label={"DOB"}
//               dateFormat="DD-MM-YYYY"
//               control={control}
//               isInGridFilter={false}
//               defaultValue={null}
//               rules={{ required: false }}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="qualification"
//               name="qualification"
//               rules={{ required: true }}
//               label="Qualification"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="experience"
//               name="experience"
//               rules={{ required: true }}
//               label="Experience"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <WSTextField
//               control={control}
//               id="workingHours"
//               name="workingHours"
//               rules={{ required: true }}
//               label="Working Hours"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Typography>Documents & Verification</Typography>
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               Aadhar
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("aadhar")}
//               id="aadhar"
//               control={control}
//               isInGridFilter={false}
//               label=""
//               name="aadhar"
//               options={clientconfig.yesorno.staticOptionData}
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               License
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("license")}
//               id="license"
//               control={control}
//               label=""
//               name="license"
//               options={clientconfig.yesorno.staticOptionData}
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               Certification
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("certification")}
//               id="certification"
//               control={control}
//               label=""
//               name="certification"
//               options={clientconfig.yesorno.staticOptionData}
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               Police Verification
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("policeVerification")}
//               id="policeVerification"
//               control={control}
//               label=""
//               name="policeVerification"
//               options={clientconfig.policeVerification.staticOptionData}
//             />
//           </Grid>
//         </Grid>
//       }
//     </Grid>
//   );
// };
// export default TechnicianDrawer;








// import { Divider, Grid, Typography, Box, IconButton } from "@mui/material";
// import { useEffect, useState, useRef } from "react";
// import {
//   Control,
//   FieldErrors,
//   UseFormRegister,
//   UseFormReset,
//   UseFormSetValue,
//   useWatch,
// } from "react-hook-form";
// import http from "../../../commonFunctions/httpClient";
// import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
// import WSButton from "../../../Components/Button/WSButton";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSPhone from "../../../Components/Phone/WSPhone";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import clientconfig from "../../../Config/clientConfig.json";
// import CloseIcon from '@mui/icons-material/Close';

// interface ApiResponse {
//   success?: boolean;
//   message?: string;
//   errors?: any;
// }

// interface PrescriptionProps {
//   control?: Control<any>;
//   errors?: FieldErrors;
//   register: UseFormRegister<any>;
//   id: any;
//   reset: UseFormReset<any>;
//   noteId?: string;
//   setValue: UseFormSetValue<any>;
//   onCancel: () => void;
//   onSuccess?: () => void;
// }

// const TechnicianDrawer: React.FC<PrescriptionProps> = ({
//   control,
//   id,
//   register,
//   noteId,
//   reset,
//   setValue,
//   onCancel,
//   onSuccess,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const [vendorId, setVendorId] = useState("");
//   const [documents, setDocuments] = useState<File[]>([]);
//   const [profileImagePreview, setProfileImagePreview] = useState<string | null>(null); // ✅ NEW
  
//   // ✅ File input refs
//   const profileImageRef = useRef<HTMLInputElement>(null);

//   const formValues = useWatch({
//     control,
//     defaultValue: {
//       Name: "",
//       PhoneNumber: "",
//       FullAddress: "",
//       DateOfBirth: "",
//       Qualification: "",
//       Experience: "",
//       WorkingHours: "",
//       "Documents.0": "",
//       "Documents.1": "",
//       "Documents.2": "",
//       "Documents.3": "",
//     }
//   }) as any;

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setVendorId(userId || "");
//   }, []);

//   // ✅ NEW: Profile image change handler with preview
//   const handleProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       const previewUrl = URL.createObjectURL(file);
//       setProfileImagePreview(previewUrl);
//     }
//   };

//   const handleDocumentUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const newFiles = Array.from(e.target.files || []);
//     setDocuments(prev => [...prev, ...newFiles]);
//     e.target.value = '';
//   };

//   const removeDocument = (indexToRemove: number) => {
//     setDocuments(prev => prev.filter((_, index) => index !== indexToRemove));
//   };

//   // ✅ ProfileImage handlers
//   const handleProfileImageClick = () => {
//     profileImageRef.current?.click();
//   };

//   // ✅ Remove image preview
//   const removeProfileImage = (e: React.MouseEvent) => {
//     e.stopPropagation();
//     setProfileImagePreview(null);
//     if (profileImageRef.current) {
//       profileImageRef.current.value = '';
//     }
//   };

//   // ✅ PERFECT FormData - Backend expects ProfileImage (PascalCase)
//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const formData = new FormData();
      
//       // ✅ CRITICAL: ProfileImage from native ref (REQUIRED!)
//       const profileFile = profileImageRef.current?.files?.[0];
//       if (!profileFile) {
//         alert("Profile Image is REQUIRED!");
//         setLoading(false);
//         return;
//       }
      
//       // ✅ Backend field names (exact match)
//       formData.append("ProfileImage", profileFile);
//       formData.append("vendorId", vendorId);
//       formData.append("name", formValues.Name || "");
//       formData.append("phoneNumber", formValues.PhoneNumber || "");
//       formData.append("fullAddress", formValues.FullAddress || "");
//       formData.append("dateOfBirth", formValues.DateOfBirth || "2000-01-01T00:00:00Z");
//       formData.append("qualification", formValues.Qualification || "");
//       formData.append("experience", formValues.Experience || "1");
//       formData.append("workingHours", formValues.WorkingHours || "");
      
//       // ✅ Multiple Documents
//       documents.forEach((file) => {
//         formData.append("documents", file);
//       });

//       // ✅ Document verification
//       formData.append("hasAadhar", formValues["Documents.0"] || "false");
//       formData.append("hasLicense", formValues["Documents.1"] || "false");
//       formData.append("hasCertification", formValues["Documents.2"] || "false");
//       formData.append("hasPoliceVerification", formValues["Documents.3"] || "false");

//       console.log("📋 FINAL FORM DATA:");
//       for (let [key, value] of formData.entries()) {
//         console.log(`  ${key}:`, value);
//       }

//       const response: ApiResponse = await http.postFormData(`/pharmacy/DeliveryPerson`, formData);
      
//       console.log("✅ API RESPONSE:", response);

//       if (response?.success) {
//         alert("✅ Technician created successfully!");
//         setDocuments([]);
//         setProfileImagePreview(null);
//         if (profileImageRef.current) profileImageRef.current.value = '';
//         if (reset) reset();
//         onCancel();
//         onSuccess?.();
//       } else {
//         console.error("❌ API ERROR:", response);
//         const errorMsg = response?.message || 
//                         (response?.errors ? JSON.stringify(response.errors) : "Validation failed");
//         alert(errorMsg);
//       }
//     } catch (error: any) {
//       console.error("💥 ERROR:", error);
//       alert(error?.message || "Failed to save technician");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const isEditMode = id && id.toString().startsWith("technicianEdit-");
//     if (isEditMode) {
//       const technicianId = id.toString().replace("technicianEdit-", "");
//       loadTechnicianData(technicianId);
//     }
//   }, [id, setValue]);

//   const loadTechnicianData = async (technicianId: string) => {
//     try {
//       setLoading(true);
//       const response: any = await http.get(`/pharmacy/DeliveryPerson/${technicianId}`);
//       if (response?.success && response?.data) {
//         Object.keys(response.data).forEach((key) => {
//           setValue(key as any, response.data[key]);
//         });
//       }
//     } catch (error: any) {
//       console.error("LOAD ERROR:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Cleanup preview URL
//   useEffect(() => {
//     return () => {
//       if (reset) reset();
//       if (profileImagePreview) {
//         URL.revokeObjectURL(profileImagePreview);
//       }
//     };
//   }, [reset, profileImagePreview]);

//   return (
//     <Grid>
//       <form id={id} onSubmit={handleSubmit}>
//         <Grid container spacing={2} mt={2}>
//           {/* ROW 1: Profile + Documents */}
//           <Grid container item xs={12} spacing={2}>
//             {/* ✅ PERFECT ProfileImage with PREVIEW */}
//             <Grid item xs={12} md={6}>
//   <Box sx={{ 
//     position: 'relative', 
//     height: 200,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   }}>
//     <Box
//       sx={{
//         border: '3px dashed #1976d2',
//         borderRadius: '50%',  // ✅ ROUND SHAPE
//         width: 160,           // ✅ Fixed width for circle
//         height: 160,          // ✅ Fixed height for circle
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: '#f8faff',
//         cursor: 'pointer',
//         position: 'relative',
//         '&:hover': { 
//           backgroundColor: profileImagePreview ? '#e3f2fd' : '#e3f2fd', 
//           borderColor: '#1565c0' 
//         }
//       }}
//       onClick={handleProfileImageClick}
//     >
//       {profileImagePreview ? (
//         // ✅ SHOW SELECTED IMAGE PREVIEW - ROUND
//         <>
//           <Box sx={{ 
//             width: '80%', 
//             height: "80%",
//             borderRadius: '50%',  // ✅ ROUND IMAGE
//             overflow: 'hidden',
//             position: 'relative'
//           }}>
//             <img
//               src={profileImagePreview}
//               alt="Profile preview"
//               style={{
//                 width: '100%',
//                 height: '100%',
//                 objectFit: 'cover',  // ✅ Perfect circular crop
//                 display: 'block',
//                 borderRadius: '50%'  // ✅ Extra round safety
//               }}
//             />
//           </Box>
//           {/* ✅ REMOVE BUTTON - Positioned perfectly on circle */}
//           <IconButton
//             onClick={removeProfileImage}
//             sx={{
//               position: 'absolute',
//               top: -8,
//               right: -8,
//               backgroundColor: 'rgba(0,0,0,0.8)',
//               color: 'white',
//               width: 32,
//               height: 32,
//               minWidth: 0,
//               '&:hover': {
//                 backgroundColor: 'rgba(0,0,0,1)',
//               },
//             }}
//             size="small"
//           >
//             <CloseIcon sx={{ fontSize: 14 }} />
//           </IconButton>
//         </>
//       ) : (
//         <>
//           <Box sx={{ 
//             width: 60, 
//             height: 60, 
//             borderRadius: '50%',
//             backgroundColor: '#e3f2fd',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             mb: 1
//           }}>
            
//           </Box>
//           <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', px: 1 }}>
//             Click to upload
//           </Typography>
//           <Typography variant="caption" color="textSecondary">
//             (JPG, PNG)
//           </Typography>
//         </>
//       )}
//     </Box>
//     {/* ✅ NATIVE INPUT - Backend finds ProfileImage */}
//     <input
//       ref={profileImageRef}
//       type="file"
//       name="ProfileImage"
//       accept="image/*"
//       style={{ display: 'none' }}
//       disabled={loading}
//       onChange={handleProfileImageChange}
//       required
//     />
//   </Box>
// </Grid>

            
//             <Grid item xs={12} md={6}>
//               <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
//                 📎 Documents (Multiple)
//               </Typography>
//               <Box sx={{ 
//                 position: 'relative',
//                 border: '2px dashed #1976d2',
//                 borderRadius: 2,
//                 p: 2,
//                 textAlign: 'center',
//                 cursor: 'pointer',
//                 backgroundColor: '#f8faff',
//                 '&:hover': { backgroundColor: '#e3f2fd' }
//               }}>
//                 <input
//                   id="documents-upload"
//                   type="file"
//                   multiple
//                   accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
//                   onChange={handleDocumentUpload}
//                   style={{ display: 'none' }}
//                   disabled={loading}
//                 />
//                 <label htmlFor="documents-upload">
//                   <Typography variant="body1" color="primary">
//                     ➕ {documents.length === 0 ? 'Upload Documents' : `${documents.length} Files`}
//                   </Typography>
//                 </label>
//               </Box>
              
//               {documents.length > 0 && (
//                 <Box sx={{ mt: 1, maxHeight: 120, overflow: 'auto' }}>
//                   {documents.map((file, index) => (
//                     <Box key={index} sx={{ 
//                       display: 'flex', 
//                       alignItems: 'center', 
//                       p: 1, 
//                       bgcolor: '#e3f2fd', 
//                       borderRadius: 1, 
//                       mb: 0.5 
//                     }}>
//                       <Typography variant="caption" sx={{ flexGrow: 1, mr: 1 }}>
//                         {file.name.length > 20 ? `${file.name.substring(0, 20)}...` : file.name}
//                       </Typography>
//                       <Typography variant="caption" color="textSecondary" sx={{ mr: 1 }}>
//                         {Math.round(file.size / 1024)}KB
//                       </Typography>
//                       <IconButton size="small" onClick={() => removeDocument(index)} sx={{ p: 0.2 }}>
//                         <CloseIcon fontSize="small" />
//                       </IconButton>
//                     </Box>
//                   ))}
//                 </Box>
//               )}
//             </Grid>
//           </Grid>

//           {/* ALL FIELDS - UNCHANGED */}
//           <Grid item xs={12}>
//             <WSTextField control={control} id="Name" name="Name" rules={{ required: true }} label="Name *" disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <WSPhone label="Phone Number *" rules={{ required: true }} control={control} id="PhoneNumber" {...register("PhoneNumber")} name="PhoneNumber" disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <WSTextField control={control} id="FullAddress" name="FullAddress" rules={{ required: true }} label="Full Address *" disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <WSDateField id="DateOfBirth" name="DateOfBirth" label="Date of Birth *" dateFormat="DD-MM-YYYY" control={control} isInGridFilter={false} defaultValue="2000-01-01" rules={{ required: false }} disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <WSTextField control={control} id="Qualification" name="Qualification" rules={{ required: true }} label="Qualification *" disabled={loading} />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSTextField control={control} id="Experience" name="Experience" rules={{ required: true }} label="Experience *" disabled={loading} />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSTextField control={control} id="WorkingHours" name="WorkingHours" rules={{ required: true }} label="Working Hours *" disabled={loading} />
//           </Grid>

//           {/* Documents & Verification - UNCHANGED */}
//           <Grid item xs={12}>
//             <Typography>Documents & Verification</Typography>
//           </Grid>
          
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">Aadhar</Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.0")} 
//               id="aadhar" 
//               control={control} 
//               isInGridFilter={false} 
//               label="" 
//               name="Documents.0" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={loading} 
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">License</Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.1")} 
//               id="license" 
//               control={control} 
//               label="" 
//               name="Documents.1" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={loading} 
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">Certification</Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.2")} 
//               id="certification" 
//               control={control} 
//               label="" 
//               name="Documents.2" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={loading} 
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">Police Verification</Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.3")} 
//               id="policeVerification" 
//               control={control} 
//               label="" 
//               name="Documents.3" 
//               options={clientconfig.policeVerification.staticOptionData} 
//               disabled={loading} 
//             />
//           </Grid>
//         </Grid>
//       </form>
//     </Grid>
//   );
// };

// export default TechnicianDrawer;









// import { Divider, Grid, Typography, Box, IconButton } from "@mui/material";
// import { useEffect, useState, useRef } from "react";
// import {
//   Control,
//   FieldErrors,
//   UseFormRegister,
//   UseFormReset,
//   UseFormSetValue,
//   useWatch,
// } from "react-hook-form";
// import http from "../../../commonFunctions/httpClient";
// import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
// import WSButton from "../../../Components/Button/WSButton";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSPhone from "../../../Components/Phone/WSPhone";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import clientconfig from "../../../Config/clientConfig.json";
// import CloseIcon from '@mui/icons-material/Close';

// interface ApiResponse {
//   success?: boolean;
//   message?: string;
//   errors?: any;
// }

// interface PrescriptionProps {
//   control?: Control<any>;
//   errors?: FieldErrors;
//   register: UseFormRegister<any>;
//   id: any;
//   reset: UseFormReset<any>;
//   noteId?: string;
//   setValue: UseFormSetValue<any>;
//   onCancel: () => void;
//   onSuccess?: () => void;
// }

// const TechnicianDrawer: React.FC<PrescriptionProps> = ({
//   control,
//   id,
//   register,
//   noteId,
//   reset,
//   setValue,
//   onCancel,
//   onSuccess,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const [vendorId, setVendorId] = useState("");
//   const [documents, setDocuments] = useState<File[]>([]);
//   const [profileImagePreview, setProfileImagePreview] = useState<string | null>(null);
  
//   const profileImageRef = useRef<HTMLInputElement>(null);

//   const formValues = useWatch({
//     control,
//     defaultValue: {
//       Name: "",
//       PhoneNumber: "",
//       FullAddress: "",
//       DateOfBirth: "",
//       Qualification: "",
//       Experience: "",
//       WorkingHours: "",
//       "Documents.0": "false",
//       "Documents.1": "false",
//       "Documents.2": "false",
//       "Documents.3": "false",
//     }
//   }) as any;

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setVendorId(userId || "");
//   }, []);

//   const handleProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       const previewUrl = URL.createObjectURL(file);
//       setProfileImagePreview(previewUrl);
//     }
//   };

//   const handleDocumentUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const newFiles = Array.from(e.target.files || []);
//     setDocuments(prev => [...prev, ...newFiles]);
//     e.target.value = '';
//   };

//   const removeDocument = (indexToRemove: number) => {
//     setDocuments(prev => prev.filter((_, index) => index !== indexToRemove));
//   };

//   const handleProfileImageClick = () => {
//     profileImageRef.current?.click();
//   };

//   const removeProfileImage = (e: React.MouseEvent) => {
//     e.stopPropagation();
//     setProfileImagePreview(null);
//     if (profileImageRef.current) {
//       profileImageRef.current.value = '';
//     }
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//   e.preventDefault();
//   setLoading(true);

//   try {
//     const formData = new FormData();
    
//     const profileFile = profileImageRef.current?.files?.[0];
//     if (!profileFile) {
//       alert("❌ Profile Image is REQUIRED!");
//       setLoading(false);
//       return;
//     }
    
//     // ✅ ALL REQUIRED FIELDS + DocumentTypes FIX
//     formData.append("ProfileImage", profileFile);
//     formData.append("VendorId", vendorId);
//     formData.append("Name", formValues.Name || "");
//     formData.append("PhoneNumber", formValues.PhoneNumber || "");
//     formData.append("FullAddress", formValues.FullAddress || "");
//     formData.append("DateOfBirth", formValues.DateOfBirth || "");
//     formData.append("Qualification", formValues.Qualification || "");
//     formData.append("Experience", formValues.Experience || "0");
//     formData.append("WorkingHours", formValues.WorkingHours || "");
    
//     // ✅ DOCUMENTS - Backend expects "Documents" array
//     documents.forEach((file) => {
//       formData.append("Documents", file);
//     });
    
//     // ✅ CRITICAL FIX: Backend requires DocumentTypes array
//     // Send document types based on uploaded files or checkboxes
//     const documentTypes = ["Aadhar", "License", "Certification", "Police"]; // Default types
//     documentTypes.forEach(type => {
//       formData.append("DocumentTypes", type);
//     });

//     // ✅ Verification flags
//     formData.append("IsAadharVerified", formValues["Documents.0"] || "false");
//     formData.append("IsLicenseVerified", formValues["Documents.1"] || "false");
//     formData.append("IsCertificationVerified", formValues["Documents.2"] || "false");
//     formData.append("IsPoliceVerified", formValues["Documents.3"] || "false");

//     console.log("📋 FORM DATA:");
//     for (let [key, value] of formData.entries()) {
//       console.log(`  ${key}:`, value);
//     }

//     const response: ApiResponse = await http.postFormData(`pharmacy/DeliveryPerson`, formData);
    
//     console.log("✅ API RESPONSE:", response);

//     if (response?.success) {
//       alert(response.message || "✅ Technician created successfully!");
//       setDocuments([]);
//       setProfileImagePreview(null);
//       if (profileImageRef.current) profileImageRef.current.value = '';
//       if (reset) reset();
//       onCancel();
//       onSuccess?.();
//     } else {
//       alert(response?.message || "Failed to create technician");
//     }
//   } catch (error: any) {
//     console.error("💥 ERROR:", error?.response?.data);
//     alert(error?.response?.data?.message || "Failed to create technician");
//   } finally {
//     setLoading(false);
//   }
// };


//   useEffect(() => {
//     const isEditMode = id && id.toString().startsWith("technicianEdit-");
//     if (isEditMode) {
//       const technicianId = id.toString().replace("technicianEdit-", "");
//       loadTechnicianData(technicianId);
//     }
//   }, [id, setValue]);

//   const loadTechnicianData = async (technicianId: string) => {
//     try {
//       setLoading(true);
//       const response: any = await http.get(`pharmacy/DeliveryPerson/${technicianId}`);
//       if (response?.success && response?.data) {
//         const data = response.data;
//         setValue("Name", data.name);
//         setValue("PhoneNumber", data.phoneNumber);
//         setValue("FullAddress", data.fullAddress);
//         setValue("DateOfBirth", data.dateOfBirth?.split('T')[0] || "");
//         setValue("Qualification", data.qualification);
//         setValue("Experience", data.experience);
//         setValue("WorkingHours", data.workingHours);
//         setValue("Documents.0", data.isAadharVerified ? "true" : "false");
//         setValue("Documents.1", data.isLicenseVerified ? "true" : "false");
//         setValue("Documents.2", data.isCertificationVerified ? "true" : "false");
//         setValue("Documents.3", data.isPoliceVerified ? "true" : "false");
//       }
//     } catch (error: any) {
//       console.error("LOAD ERROR:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     return () => {
//       if (profileImagePreview) {
//         URL.revokeObjectURL(profileImagePreview);
//       }
//     };
//   }, [profileImagePreview]);

//   return (
//     <Grid>
//       <form id={id} onSubmit={handleSubmit}>
//         <Grid container spacing={2} mt={2}>
//           {/* ROW 1: Profile + Documents */}
//           <Grid container item xs={12} spacing={2}>
//             <Grid item xs={12} md={6}>
//               <Box sx={{ 
//                 position: 'relative', 
//                 height: 200,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}>
//                 <Box
//                   sx={{
//                     border: '3px dashed #1976d2',
//                     borderRadius: '50%',
//                     width: 160,
//                     height: 160,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     backgroundColor: '#f8faff',
//                     cursor: 'pointer',
//                     position: 'relative',
//                     '&:hover': { 
//                       backgroundColor: profileImagePreview ? '#e3f2fd' : '#e3f2fd', 
//                       borderColor: '#1565c0' 
//                     }
//                   }}
//                   onClick={handleProfileImageClick}
//                 >
//                   {profileImagePreview ? (
//                     <>
//                       <Box sx={{ 
//                         width: '80%', 
//                         height: "80%",
//                         borderRadius: '50%',
//                         overflow: 'hidden',
//                         position: 'relative'
//                       }}>
//                         <img
//                           src={profileImagePreview}
//                           alt="Profile preview"
//                           style={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'cover',
//                             display: 'block',
//                             borderRadius: '50%'
//                           }}
//                         />
//                       </Box>
//                       <IconButton
//                         onClick={removeProfileImage}
//                         sx={{
//                           position: 'absolute',
//                           top: -8,
//                           right: -8,
//                           backgroundColor: 'rgba(0,0,0,0.8)',
//                           color: 'white',
//                           width: 32,
//                           height: 32,
//                           minWidth: 0,
//                           '&:hover': { backgroundColor: 'rgba(0,0,0,1)' },
//                         }}
//                         size="small"
//                       >
//                         <CloseIcon sx={{ fontSize: 14 }} />
//                       </IconButton>
//                     </>
//                   ) : (
//                     <>
//                       <Box sx={{ 
//                         width: 60, 
//                         height: 60, 
//                         borderRadius: '50%',
//                         backgroundColor: '#e3f2fd',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         mb: 1
//                       }}></Box>
//                       <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', px: 1 }}>
//                         Click to upload
//                       </Typography>
//                       <Typography variant="caption" color="textSecondary">
//                         (JPG, PNG)
//                       </Typography>
//                     </>
//                   )}
//                 </Box>
//                 <input
//                   ref={profileImageRef}
//                   type="file"
//                   name="ProfileImage"
//                   accept="image/*"
//                   style={{ display: 'none' }}
//                   disabled={loading}
//                   onChange={handleProfileImageChange}
//                   required
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
//                 📎 Documents (Multiple)
//               </Typography>
//               <Box sx={{ 
//                 position: 'relative',
//                 border: '2px dashed #1976d2',
//                 borderRadius: 2,
//                 p: 2,
//                 textAlign: 'center',
//                 cursor: 'pointer',
//                 backgroundColor: '#f8faff',
//                 '&:hover': { backgroundColor: '#e3f2fd' }
//               }}>
//                 <input
//                   id="documents-upload"
//                   type="file"
//                   multiple
//                   accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
//                   onChange={handleDocumentUpload}
//                   style={{ display: 'none' }}
//                   disabled={loading}
//                 />
//                 <label htmlFor="documents-upload">
//                   <Typography variant="body1" color="primary">
//                     ➕ {documents.length === 0 ? 'Upload Documents' : `${documents.length} Files`}
//                   </Typography>
//                 </label>
//               </Box>
//               {documents.length > 0 && (
//                 <Box sx={{ mt: 1, maxHeight: 120, overflow: 'auto' }}>
//                   {documents.map((file, index) => (
//                     <Box key={index} sx={{ 
//                       display: 'flex', 
//                       alignItems: 'center', 
//                       p: 1, 
//                       bgcolor: '#e3f2fd', 
//                       borderRadius: 1, 
//                       mb: 0.5 
//                     }}>
//                       <Typography variant="caption" sx={{ flexGrow: 1, mr: 1 }}>
//                         {file.name.length > 20 ? `${file.name.substring(0, 20)}...` : file.name}
//                       </Typography>
//                       <Typography variant="caption" color="textSecondary" sx={{ mr: 1 }}>
//                         {Math.round(file.size / 1024)}KB
//                       </Typography>
//                       <IconButton size="small" onClick={() => removeDocument(index)} sx={{ p: 0.2 }}>
//                         <CloseIcon fontSize="small" />
//                       </IconButton>
//                     </Box>
//                   ))}
//                 </Box>
//               )}
//             </Grid>
//           </Grid>

//           <Grid item xs={12}>
//             <WSTextField control={control} id="Name" name="Name" rules={{ required: true }} label="Name *" disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <WSPhone label="Phone Number *" rules={{ required: true }} control={control} id="PhoneNumber" {...register("PhoneNumber")} name="PhoneNumber" disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <WSTextField control={control} id="FullAddress" name="FullAddress" rules={{ required: true }} label="Full Address *" disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <WSDateField id="DateOfBirth" name="DateOfBirth" label="Date of Birth *" dateFormat="DD-MM-YYYY" control={control} isInGridFilter={false} defaultValue="2000-01-01" rules={{ required: true }} disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <WSTextField control={control} id="Qualification" name="Qualification" rules={{ required: true }} label="Qualification *" disabled={loading} />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSTextField control={control} id="Experience" name="Experience" rules={{ required: true }} label="Experience (Years) *"  disabled={loading} />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSTextField control={control} id="WorkingHours" name="WorkingHours" rules={{ required: true }} label="Working Hours *" disabled={loading} />
//           </Grid>

//           <Grid item xs={12}>
//             <Typography variant="h6" sx={{ mb: 2 }}>Documents & Verification</Typography>
//           </Grid>
          
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">Aadhar</Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.0")} 
//               id="aadhar" 
//               control={control} 
//               isInGridFilter={false} 
//               label="" 
//               name="Documents.0" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={loading} 
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">License</Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.1")} 
//               id="license" 
//               control={control} 
//               label="" 
//               name="Documents.1" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={loading} 
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">Certification</Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.2")} 
//               id="certification" 
//               control={control} 
//               label="" 
//               name="Documents.2" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={loading} 
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">Police Verification</Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.3")} 
//               id="policeVerification" 
//               control={control} 
//               label="" 
//               name="Documents.3" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={loading} 
//             />
//           </Grid>
//         </Grid>
//       </form>
//     </Grid>
//   );
// };

// export default TechnicianDrawer;










// import { Divider, Grid, Typography, Box, IconButton } from "@mui/material";
// import { useEffect, useState, useRef } from "react";
// import {
//   Control,
//   FieldErrors,
//   UseFormRegister,
//   UseFormReset,
//   UseFormSetValue,
//   useWatch,
// } from "react-hook-form";
// import http from "../../../commonFunctions/httpClient";
// import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
// import WSButton from "../../../Components/Button/WSButton";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSPhone from "../../../Components/Phone/WSPhone";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import clientconfig from "../../../Config/clientConfig.json";
// import config from "../../../Config/config.json";
// import CloseIcon from '@mui/icons-material/Close';

// interface ApiResponse {
//   success?: boolean;
//   message?: string;
//   errors?: any;
//   data?: any;
// }

// interface DocumentPreview {
//   id: string;
//   name: string;
//   type: string;
//   url: string;
//   size: number;
// }

// interface PrescriptionProps {
//   control?: Control<any>;
//   errors?: FieldErrors;
//   register: UseFormRegister<any>;
//   id: any;
//   reset: UseFormReset<any>;
//   noteId?: string;
//   setValue: UseFormSetValue<any>;
//   onCancel: () => void;
//   onSuccess?: () => void;
// }

// const TechnicianDrawer: React.FC<PrescriptionProps> = ({
//   control,
//   id,
//   register,
//   noteId,
//   reset,
//   setValue,
//   onCancel,
//   onSuccess,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const [vendorId, setVendorId] = useState("");
//   const [documents, setDocuments] = useState<File[]>([]); // NEW uploads
//   const [existingDocuments, setExistingDocuments] = useState<DocumentPreview[]>([]); // Existing from API
//   const [profileImagePreview, setProfileImagePreview] = useState<string | null>(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [technicianId, setTechnicianId] = useState("");
  
//   const profileImageRef = useRef<HTMLInputElement>(null);

//   const formValues = useWatch({
//     control,
//     defaultValue: {
//       Name: "",
//       PhoneNumber: "",
//       FullAddress: "",
//       DateOfBirth: "",
//       Qualification: "",
//       Experience: "",
//       WorkingHours: "",
//       "Documents.0": "false",
//       "Documents.1": "false",
//       "Documents.2": "false",
//       "Documents.3": "false",
//     }
//   }) as any;

//   // ✅ Get vendor ID
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setVendorId(userId || "");
//   }, []);

//   // ✅ PERFECT EDIT MODE DETECTION + DATA LOADING
//   useEffect(() => {
//     const editMode = id && id.toString().startsWith("technicianEdit-");
//     console.log("🔍 ID CHECK:", id, "EditMode:", editMode);
    
//     if (editMode && control) {
//       const techId = id.toString().replace("technicianEdit-", "");
//       console.log("🎯 EDIT MODE - Loading technician:", techId);
//       setIsEditMode(true);
//       setTechnicianId(techId);
//       loadTechnicianData(techId);
//     } else {
//       setIsEditMode(false);
//       setTechnicianId("");
//       // Clear data on create mode
//       setExistingDocuments([]);
//       setProfileImagePreview(null);
//       setDocuments([]);
//     }
//   }, [id, control]);

//   // 🔥 FIXED: Complete data loading with DOCUMENTS & PROFILE
//   // 🔥 FIXED: Complete data loading with PROPER BOOLEAN-TO-STRING MAPPING
// const loadTechnicianData = async (techId: string) => {
//   try {
//     setLoading(true);
//     console.log("📡 Fetching technician:", techId);
    
//     const response: any = await http.get(`pharmacy/DeliveryPerson/${techId}`);
//     console.log("✅ FULL API RESPONSE:", response);
    
//     if (response?.success && response?.data) {
//       const data = response.data;
      
//       setTimeout(() => {
//         if (setValue) {
//           // ✅ Basic form fields
//           setValue("Name", data.name || "");
//           setValue("PhoneNumber", data.phoneNumber || "");
//           setValue("FullAddress", data.fullAddress || "");
//           setValue("DateOfBirth", data.dateOfBirth ? data.dateOfBirth.split('T')[0] : "");
//           setValue("Qualification", data.qualification || "");
//           setValue("Experience", data.experience?.toString() || "0");
//           setValue("WorkingHours", data.workingHours || "");
          
//           // 🔥 FIXED: Boolean to String mapping for dropdowns ✅
//           // API returns: true/false → UI needs: "yes"/"no" strings
//           const booleanToString = (value: any): string => {
//             return value === true || value === "true" ? "yes" : "no";
//           };
          
//           setValue("Documents.0", booleanToString(data.isAadharVerified));
//           setValue("Documents.1", booleanToString(data.isLicenseVerified));
//           setValue("Documents.2", booleanToString(data.isCertificationVerified));
//           setValue("Documents.3", booleanToString(data.isPoliceVerified));
          
//           console.log("✅ FORM POPULATED WITH YES/NO:", {
//             name: data.name,
//             isAadharVerified: data.isAadharVerified,
//             aadharUI: booleanToString(data.isAadharVerified),
//             documentsCount: data.documents?.length || 0
//           });
//         }
        
//         // ✅ Profile image preview
//         if (data.profileImageUrl) {
//           setProfileImagePreview(`${config.imgUrl}${data.profileImageUrl}`);
//           console.log("🖼️ Profile image loaded:", data.profileImageUrl);
//         }
        
//         // 🔥 Load EXISTING DOCUMENTS
//         if (data.documents && Array.isArray(data.documents) && data.documents.length > 0) {
//           console.log("📂 LOADING EXISTING DOCUMENTS:", data.documents);
          
//           const docPreviews: DocumentPreview[] = data.documents.map((doc: any) => ({
//             id: doc.id,
//             name: doc.documentType ? `${doc.documentType.toLowerCase()}.pdf` : `document_${doc.id}.pdf`,
//             type: doc.documentType || 'Document',
//             url: `${config.imgUrl}${doc.documentUrl}`,
//             size: 0
//           }));
          
//           setExistingDocuments(docPreviews);
//           console.log("✅ EXISTING DOCUMENTS LOADED:", docPreviews);
//         }
//       }, 200);
//     }
//   } catch (error: any) {
//     console.error("💥 LOAD ERROR:", error);
//   } finally {
//     setLoading(false);
//   }
// };

//   const handleProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       const previewUrl = URL.createObjectURL(file);
//       setProfileImagePreview(previewUrl);
//     }
//   };

//   const handleDocumentUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const newFiles = Array.from(e.target.files || []);
//     setDocuments(prev => [...prev, ...newFiles]);
//     e.target.value = '';
//   };

//   const removeDocument = (indexToRemove: number) => {
//     setDocuments(prev => prev.filter((_, index) => index !== indexToRemove));
//   };

//   const removeExistingDocument = (docId: string) => {
//     setExistingDocuments(prev => prev.filter(doc => doc.id !== docId));
//   };

//   const handleProfileImageClick = () => {
//     profileImageRef.current?.click();
//   };

//   const removeProfileImage = (e: React.MouseEvent) => {
//     e.stopPropagation();
//     setProfileImagePreview(null);
//     if (profileImageRef.current) {
//       profileImageRef.current.value = '';
//     }
//   };

//   // ✅ FIXED: CREATE + EDIT with correct field names + PUT API
//   // Replace your TechnicianDrawer handleSubmit with this FIXED version:
// const handleSubmit = async (e: React.FormEvent) => {
//   e.preventDefault();
//   setLoading(true);

//   try {
//     const formData = new FormData();
    
//     // ✅ Profile image (optional)
//     const profileFile = profileImageRef.current?.files?.[0];
//     if (profileFile) {
//       formData.append("ProfileImage", profileFile);
//     }
    
//     // ✅ Form fields - EXACT API names
//     formData.append("VendorId", vendorId);
//     formData.append("Name", formValues.Name || "");
//     formData.append("PhoneNumber", formValues.PhoneNumber || "");
//     formData.append("FullAddress", formValues.FullAddress || "");
//     formData.append("DateOfBirth", formValues.DateOfBirth || "");
//     formData.append("Qualification", formValues.Qualification || "");
//     formData.append("Experience", formValues.Experience || "0");
//     formData.append("WorkingHours", formValues.WorkingHours || "");
    
//     // ✅ New documents upload
//     documents.forEach((file) => {
//       formData.append("Documents", file);
//     });
    
//     // ✅ Document type mapping for new uploads
//     const documentTypes = ["Aadhar", "License", "Certification", "Police"];
//     documentTypes.forEach(type => {
//       formData.append("DocumentTypes", type);
//     });
    
//     // ✅ Verification status - STRING values
//     formData.append("IsAadharVerified", formValues["Documents.0"] || "false");
//     formData.append("IsLicenseVerified", formValues["Documents.1"] || "false");
//     formData.append("IsCertificationVerified", formValues["Documents.2"] || "false");
//     formData.append("IsPoliceVerified", formValues["Documents.3"] || "false");

//     console.log("📤 SUBMITTING:", isEditMode ? "UPDATE" : "CREATE");
    
//     let response: any;
    
//     // 🔥 CREATE vs UPDATE API calls
//     if (isEditMode && technicianId) {
//       // ✅ UPDATE API
//       response = await http.putFormData(`pharmacy/DeliveryPerson/${technicianId}`, formData);
//       console.log("✅ UPDATE RESPONSE:", response);
//     } else {
//       // ✅ CREATE API  
//       response = await http.postFormData(`pharmacy/DeliveryPerson`, formData);
//       console.log("✅ CREATE RESPONSE:", response);
//     }

//     if (response?.success) {
//       alert(response.message || (isEditMode ? "✅ Technician updated successfully!" : "✅ Technician created!"));
      
//       // ✅ Reset everything
//       setDocuments([]);
//       setProfileImagePreview(null);
//       setExistingDocuments([]);
//       if (profileImageRef.current) profileImageRef.current.value = '';
//       if (reset) reset();
      
//       onCancel();
//       onSuccess?.();
//     } else {
//       alert(response?.message || "succesfully save technician");
//     }
//   } catch (error: any) {
//     console.error("💥 ERROR:", error);
//     alert(error?.response?.data?.message || "Failed to save technician");
//   } finally {
//     setLoading(false);
//   }
// };


//   useEffect(() => {
//     return () => {
//       if (profileImagePreview && !profileImagePreview.startsWith(config.imgUrl)) {
//         URL.revokeObjectURL(profileImagePreview);
//       }
//     };
//   }, [profileImagePreview]);

//   return (
//     <Grid>
//       <form id={id} onSubmit={handleSubmit}>
//         <Grid container spacing={2} mt={2}>
//           {/* 🔥 Profile + Documents - ENHANCED ✅ */}
//           <Grid container item xs={12} spacing={2}>
//             <Grid item xs={12} md={6}>
//               <Box sx={{ position: 'relative', height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 <Box sx={{
//                   border: '3px dashed #1976d2',
//                   borderRadius: '50%',
//                   width: 160,
//                   height: 160,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   backgroundColor: '#f8faff',
//                   cursor: 'pointer',
//                   position: 'relative',
//                   '&:hover': { 
//                     backgroundColor: profileImagePreview ? '#e3f2fd' : '#e3f2fd', 
//                     borderColor: '#1565c0' 
//                   }
//                 }} onClick={handleProfileImageClick}>
//                   {profileImagePreview ? (
//                     <>
//                       <Box sx={{ width: '80%', height: "80%", borderRadius: '50%', overflow: 'hidden', position: 'relative' }}>
//                         <img 
//                           src={profileImagePreview} 
//                           alt="Profile preview" 
//                           style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: '50%' }} 
//                         />
//                       </Box>
//                       <IconButton onClick={removeProfileImage} sx={{ position: 'absolute', top: -8, right: -8, backgroundColor: 'rgba(0,0,0,0.8)', color: 'white', width: 32, height: 32, minWidth: 0, '&:hover': { backgroundColor: 'rgba(0,0,0,1)' } }} size="small">
//                         <CloseIcon sx={{ fontSize: 14 }} />
//                       </IconButton>
//                     </>
//                   ) : (
//                     <>
//                       <Box sx={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#e3f2fd', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}></Box>
//                       <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', px: 1 }}>Click to upload</Typography>
//                       <Typography variant="caption" color="textSecondary">(JPG, PNG)</Typography>
//                     </>
//                   )}
//                 </Box>
//                 <input
//                   ref={profileImageRef}
//                   type="file"
//                   name="ProfileImage"
//                   accept="image/*"
//                   style={{ display: 'none' }}
//                   disabled={loading}
//                   onChange={handleProfileImageChange}
//                 />
//               </Box>
//             </Grid>

//             {/* 🔥 DOCUMENTS SECTION - SPLIT EXISTING + NEW */}
//             <Grid item xs={12} md={6}>
//               <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
//                 📎 Documents ({existingDocuments.length + documents.length})
//               </Typography>
              
//               {/* ✅ EXISTING DOCUMENTS */}
//               {existingDocuments.length > 0 && (
//                 <Box sx={{ mb: 2 }}>
//                   <Typography variant="caption" color="success.main" sx={{ fontWeight: 500 }}>
//                     Existing ({existingDocuments.length})
//                   </Typography>
//                   {existingDocuments.map((doc) => (
//                     <Box key={doc.id} sx={{ display: 'flex', alignItems: 'center', p: 1, bgcolor: '#e8f5e8', borderRadius: 1, mb: 0.5 }}>
//                       <Typography variant="caption" sx={{ flexGrow: 1, mr: 1 }}>
//                         {doc.type} 
//                       </Typography>
//                       <Box 
//                         component="img" 
//                         src={doc.url} 
//                         sx={{ width: 30, height: 30, borderRadius: 1, mr: 1, objectFit: 'cover', backgroundColor: '#f0f0f0' }}
//                         onError={(e: any) => {
//                           e.target.style.display = 'none';
//                           e.target.nextSibling!.textContent = '📄';
//                         }}
//                       />
//                       <span style={{ fontSize: '20px' }}>✓</span>
//                       {isEditMode && (
//                         <IconButton size="small" onClick={() => removeExistingDocument(doc.id)} sx={{ p: 0.2 }}>
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                       )}
//                     </Box>
//                   ))}
//                 </Box>
//               )}
              
//               {/* ✅ NEW UPLOADS */}
//               <Box sx={{ position: 'relative', border: '2px dashed #1976d2', borderRadius: 2, p: 2, textAlign: 'center', cursor: 'pointer', backgroundColor: '#f8faff', '&:hover': { backgroundColor: '#e3f2fd' } }}>
//                 <input id="documents-upload" type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onChange={handleDocumentUpload} style={{ display: 'none' }} disabled={loading} />
//                 <label htmlFor="documents-upload">
//                   <Typography variant="body1" color="primary">
//                     ➕ {documents.length === 0 ? 'Upload New Documents' : `${documents.length} New Files`}
//                   </Typography>
//                 </label>
//               </Box>
              
//               {/* ✅ NEW DOCUMENTS LIST */}
//               {documents.length > 0 && (
//                 <Box sx={{ mt: 1, maxHeight: 120, overflow: 'auto' }}>
//                   {documents.map((file, index) => (
//                     <Box key={`new-${index}`} sx={{ display: 'flex', alignItems: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1, mb: 0.5 }}>
//                       <Typography variant="caption" sx={{ flexGrow: 1, mr: 1 }}>
//                         {file.name.length > 20 ? `${file.name.substring(0, 20)}...` : file.name}
//                       </Typography>
//                       <Typography variant="caption" color="textSecondary" sx={{ mr: 1 }}>
//                         {Math.round(file.size / 1024)}KB
//                       </Typography>
//                       <IconButton size="small" onClick={() => removeDocument(index)} sx={{ p: 0.2 }}>
//                         <CloseIcon fontSize="small" />
//                       </IconButton>
//                     </Box>
//                   ))}
//                 </Box>
//               )}
//             </Grid>
//           </Grid>

//           {/* ✅ ALL FORM FIELDS */}
//           <Grid item xs={12}><WSTextField control={control} id="Name" name="Name" rules={{ required: true }} label="Name *" disabled={loading} /></Grid>
//           <Grid item xs={12}><WSPhone label="Phone Number *" rules={{ required: true }} control={control} id="PhoneNumber" {...register("PhoneNumber")} name="PhoneNumber" disabled={loading} /></Grid>
//           <Grid item xs={12}><WSTextField control={control} id="FullAddress" name="FullAddress" rules={{ required: true }} label="Full Address *" disabled={loading} /></Grid>
//           <Grid item xs={12}><WSDateField id="DateOfBirth" name="DateOfBirth" label="Date of Birth *" dateFormat="DD-MM-YYYY" control={control} isInGridFilter={false} defaultValue="" rules={{ required: true }} disabled={loading} /></Grid>
//           <Grid item xs={12}><WSTextField control={control} id="Qualification" name="Qualification" rules={{ required: true }} label="Qualification *" disabled={loading} /></Grid>
//           <Grid item xs={12}><WSTextField control={control} id="Experience" name="Experience" rules={{ required: true }} label="Experience (Years) *" disabled={loading} /></Grid>
//           <Grid item xs={12}><WSTextField control={control} id="WorkingHours" name="WorkingHours" rules={{ required: true }} label="Working Hours *" disabled={loading} /></Grid>

//           {/* ✅ VERIFICATION FIELDS */}
//           <Grid item xs={12}><Typography variant="h6" sx={{ mb: 2 }}>Documents & Verification</Typography></Grid>
//           <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Aadhar</Typography></Grid><Grid item xs={12} sm={2}><WSSelectField rules={{ required: true }} {...register("Documents.0")} id="aadhar" control={control} isInGridFilter={false} label="" name="Documents.0" options={clientconfig.yesorno.staticOptionData} disabled={loading} /></Grid>
//           <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">License</Typography></Grid><Grid item xs={12} sm={2}><WSSelectField rules={{ required: true }} {...register("Documents.1")} id="license" control={control} label="" name="Documents.1" options={clientconfig.yesorno.staticOptionData} disabled={loading} /></Grid>
//           <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Certification</Typography></Grid><Grid item xs={12} sm={2}><WSSelectField rules={{ required: true }} {...register("Documents.2")} id="certification" control={control} label="" name="Documents.2" options={clientconfig.yesorno.staticOptionData} disabled={loading} /></Grid>
//           <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Police Verification</Typography></Grid><Grid item xs={12} sm={2}><WSSelectField rules={{ required: true }} {...register("Documents.3")} id="policeVerification" control={control} label="" name="Documents.3" options={clientconfig.yesorno.staticOptionData} disabled={loading} /></Grid>
//         </Grid>
//       </form>
//     </Grid>
//   );
// };

// export default TechnicianDrawer;





// import { Divider, Grid, Typography, Box, IconButton } from "@mui/material";
// import { useEffect, useState, useRef, useCallback } from "react";
// import {
//   Control,
//   FieldErrors,
//   UseFormRegister,
//   UseFormReset,
//   UseFormSetValue,
//   useWatch,
// } from "react-hook-form";
// import http from "../../../commonFunctions/httpClient";
// import { dateFormat, getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
// import WSButton from "../../../Components/Button/WSButton";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSPhone from "../../../Components/Phone/WSPhone";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import clientconfig from "../../../Config/clientConfig.json";
// import config from "../../../Config/config.json";
// import CloseIcon from '@mui/icons-material/Close';

// interface ApiResponse {
//   success?: boolean;
//   message?: string;
//   errors?: any;
//   data?: any;
// }

// interface DocumentPreview {
//   id: string;
//   name: string;
//   type: string;
//   url: string;
//   size: number;
// }

// interface PrescriptionProps {
//   control?: Control<any>;
//   errors?: FieldErrors;
//   register: UseFormRegister<any>;
//   id: any;
//   reset: UseFormReset<any>;
//   noteId?: string;
//   setValue: UseFormSetValue<any>;
//   onCancel: () => void;
//   onSuccess?: () => void;
// }

// const TechnicianDrawer: React.FC<PrescriptionProps> = ({
//   control,
//   id,
//   register,
//   reset,
//   setValue,
//   onCancel,
//   onSuccess,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const [vendorId, setVendorId] = useState("");
//   const [documents, setDocuments] = useState<File[]>([]);
//   const [existingDocuments, setExistingDocuments] = useState<DocumentPreview[]>([]);
//   const [profileImagePreview, setProfileImagePreview] = useState<string | null>(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [technicianId, setTechnicianId] = useState("");
//   const [dataLoaded, setDataLoaded] = useState(true); // ✅ ADD mode starts ENABLED
  
//   const profileImageRef = useRef<HTMLInputElement>(null);
//   const hasLoadedRef = useRef(false);

//   const formValues = useWatch({
//     control,
//   }) as any;

//   // ✅ Get vendor ID
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setVendorId(userId || "");
//   }, []);

//   // 🔥 FIXED MAIN EFFECT: Proper ADD/EDIT logic
//   useEffect(() => {
//     const editMode = id && id.toString().startsWith("technicianEdit-");
    
//     // 🔧 Reset ALL state when drawer opens
//     setIsEditMode(editMode);
//     setTechnicianId("");
//     setExistingDocuments([]);
//     setProfileImagePreview(null);
//     setDocuments([]);
    
//     // ✅ ADD mode: dataLoaded = true (fields ENABLED)
//     // EDIT mode: dataLoaded = false (wait for load)
//     setDataLoaded(!editMode);
//     hasLoadedRef.current = false;
    
//     if (editMode && control) {
//       const techId = id.toString().replace("technicianEdit-", "");
//       setTechnicianId(techId);
//       loadTechnicianData(techId);
//     }
//   }, [id, control]);

//   // 🔥 FIXED: Load data ONLY for EDIT mode
//   const loadTechnicianData = useCallback(async (techId: string) => {
//     if (hasLoadedRef.current || loading) return;
    
//     try {
//       hasLoadedRef.current = true;
//       setLoading(true);
//       console.log("📡 Fetching technician:", techId);
      
//       const response: any = await http.get(`pharmacy/DeliveryPerson/${techId}`);
//       console.log("✅ FULL API RESPONSE:", response);
      
//       if (response?.success && response?.data) {
//         const data = response.data;
        
//         // 🔧 Reset form first
//         if (reset) {
//           reset({
//             Name: "",
//             PhoneNumber: "",
//             FullAddress: "",
//             DateOfBirth: "",
//             Qualification: "",
//             Experience: "",
//             WorkingHours: "",
//             "Documents.0": "no",
//             "Documents.1": "no",
//             "Documents.2": "no",
//             "Documents.3": "no",
//           });
//         }
        
//         setTimeout(() => {
//           if (setValue) {
//             // ✅ Populate form fields
//             setValue("Name", data.name || "");
//             setValue("PhoneNumber", data.phoneNumber || "");
//             setValue("FullAddress", data.fullAddress || "");
//             // setValue("DateOfBirth", data.dateOfBirth ? data.dateOfBirth.split('T')[0] : "");
//             setValue('DateOfBirth', dateFormat(data?.dateOfBirth, 'DD-MM-YYYY HH:mm:ss'))
//             setValue("Qualification", data.qualification || "");
//             setValue("Experience", data.experience?.toString() || "0");
//             setValue("WorkingHours", data.workingHours || "");
            
//             const booleanToString = (value: any): string => {
//               return value === true || value === "true" ? "yes" : "no";
//             };
            
//             setValue("Documents.0", booleanToString(data.isAadharVerified));
//             setValue("Documents.1", booleanToString(data.isLicenseVerified));
//             setValue("Documents.2", booleanToString(data.isCertificationVerified));
//             setValue("Documents.3", booleanToString(data.isPoliceVerified));
            
//             console.log("✅ FORM POPULATED");
//           }
          
//           if (data.profileImageUrl) {
//             setProfileImagePreview(`${config.imgUrl}${data.profileImageUrl}`);
//           }
          
//           if (data.documents && Array.isArray(data.documents)) {
//             const docPreviews: DocumentPreview[] = data.documents.map((doc: any) => ({
//               id: doc.id,
//               name: doc.documentType ? `${doc.documentType.toLowerCase()}.pdf` : `document_${doc.id}.pdf`,
//               type: doc.documentType || 'Document',
//               url: `${config.imgUrl}${doc.documentUrl}`,
//               size: 0
//             }));
//             setExistingDocuments(docPreviews);
//           }
          
//           setDataLoaded(true); // ✅ ENABLE fields after loading
//         }, 100);
//       }
//     } catch (error: any) {
//       console.error("💥 LOAD ERROR:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [setValue, reset]);

//   const handleProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       const previewUrl = URL.createObjectURL(file);
//       setProfileImagePreview(previewUrl);
//     }
//   };

//   const handleDocumentUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const newFiles = Array.from(e.target.files || []);
//     setDocuments(prev => [...prev, ...newFiles]);
//     e.target.value = '';
//   };

//   const removeDocument = (indexToRemove: number) => {
//     setDocuments(prev => prev.filter((_, index) => index !== indexToRemove));
//   };

//   const removeExistingDocument = (docId: string) => {
//     setExistingDocuments(prev => prev.filter(doc => doc.id !== docId));
//   };

//   const handleProfileImageClick = () => {
//     profileImageRef.current?.click();
//   };

//   const removeProfileImage = (e: React.MouseEvent) => {
//     e.stopPropagation();
//     setProfileImagePreview(null);
//     if (profileImageRef.current) {
//       profileImageRef.current.value = '';
//     }
//   };

//   // ✅ FIXED: Submit logic
//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
    
//     // ✅ ADD mode: Always allow
//     // EDIT mode: Wait for data
//     if (loading || (isEditMode && !dataLoaded)) {
//       console.log("⏳ Loading...");
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const formData = new FormData();
      
//       const profileFile = profileImageRef.current?.files?.[0];
//       if (profileFile) formData.append("ProfileImage", profileFile);
      
//       formData.append("VendorId", vendorId);
//       formData.append("Name", formValues?.Name || "");
//       formData.append("PhoneNumber", formValues?.PhoneNumber || "");
//       formData.append("FullAddress", formValues?.FullAddress || "");
//       formData.append("DateOfBirth", formValues?.DateOfBirth || "");
//       formData.append("Qualification", formValues?.Qualification || "");
//       formData.append("Experience", formValues?.Experience || "0");
//       formData.append("WorkingHours", formValues?.WorkingHours || "");
      
//       documents.forEach((file) => formData.append("Documents", file));
      
//       const documentTypes = ["Aadhar", "License", "Certification", "Police"];
//       documentTypes.forEach(type => formData.append("DocumentTypes", type));
      
//       formData.append("IsAadharVerified", formValues?.["Documents.0"] || "false");
//       formData.append("IsLicenseVerified", formValues?.["Documents.1"] || "false");
//       formData.append("IsCertificationVerified", formValues?.["Documents.2"] || "false");
//       formData.append("IsPoliceVerified", formValues?.["Documents.3"] || "false");

//       console.log("📤 SUBMITTING:", isEditMode ? "UPDATE" : "CREATE");
      
//       let response: any;
//       if (isEditMode && technicianId) {
//         response = await http.putFormData(`pharmacy/DeliveryPerson/${technicianId}`, formData);
//       } else {
//         response = await http.postFormData(`pharmacy/DeliveryPerson`, formData);
//       }

//       if (response?.success) {
//         alert(response.message || (isEditMode ? "✅ Technician updated!" : "✅ Technician created!"));
//         setDocuments([]);
//         setProfileImagePreview(null);
//         setExistingDocuments([]);
//         if (profileImageRef.current) profileImageRef.current.value = '';
//         if (reset) reset();
//         onCancel();
//         onSuccess?.();
//       } else {
//         alert(response?.message || "Successfully saved technician");
//       }
//     } catch (error: any) {
//       console.error("💥 ERROR:", error);
//       alert(error?.response?.data?.message || "Failed to save technician");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🔥 CRITICAL: FIXED DISABLED LOGIC
//   const isFieldDisabled = loading || (isEditMode && !dataLoaded);

//   useEffect(() => {
//     return () => {
//       if (profileImagePreview && !profileImagePreview.startsWith(config.imgUrl)) {
//         URL.revokeObjectURL(profileImagePreview);
//       }
//     };
//   }, [profileImagePreview]);

//   return (
//     <Grid>
//       <form id={id} onSubmit={handleSubmit}>
//         <Grid container spacing={2} mt={2}>
//           {/* Profile + Documents */}
//           <Grid container item xs={12} spacing={2}>
//             <Grid item xs={12} md={6}>
//               <Box sx={{ position: 'relative', height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 <Box sx={{
//                   border: '3px dashed #1976d2',
//                   borderRadius: '50%',
//                   width: 160,
//                   height: 160,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   backgroundColor: '#f8faff',
//                   cursor: 'pointer',
//                   position: 'relative',
//                   '&:hover': { 
//                     backgroundColor: profileImagePreview ? '#e3f2fd' : '#e3f2fd', 
//                     borderColor: '#1565c0' 
//                   }
//                 }} onClick={handleProfileImageClick}>
//                   {profileImagePreview ? (
//                     <>
//                       <Box sx={{ width: '80%', height: "80%", borderRadius: '50%', overflow: 'hidden', position: 'relative' }}>
//                         <img 
//                           src={profileImagePreview} 
//                           alt="Profile preview" 
//                           style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: '50%' }} 
//                         />
//                       </Box>
//                       <IconButton onClick={removeProfileImage} sx={{ position: 'absolute', top: -8, right: -8, backgroundColor: 'rgba(0,0,0,0.8)', color: 'white', width: 32, height: 32, minWidth: 0, '&:hover': { backgroundColor: 'rgba(0,0,0,1)' } }} size="small">
//                         <CloseIcon sx={{ fontSize: 14 }} />
//                       </IconButton>
//                     </>
//                   ) : (
//                     <>
//                       <Box sx={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#e3f2fd', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}></Box>
//                       <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', px: 1 }}>Click to upload</Typography>
//                       <Typography variant="caption" color="textSecondary">(JPG, PNG)</Typography>
//                     </>
//                   )}
//                 </Box>
//                 <input
//                   ref={profileImageRef}
//                   type="file"
//                   name="ProfileImage"
//                   accept="image/*"
//                   style={{ display: 'none' }}
//                   disabled={loading}
//                   onChange={handleProfileImageChange}
//                 />
//               </Box>
//             </Grid>

//             {/* Documents Section */}
//             <Grid item xs={12} md={6}>
//               <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
//                 📎 Documents ({existingDocuments.length + documents.length})
//               </Typography>
              
//               {existingDocuments.length > 0 && (
//                 <Box sx={{ mb: 2 }}>
//                   <Typography variant="caption" color="success.main" sx={{ fontWeight: 500 }}>
//                     Existing ({existingDocuments.length})
//                   </Typography>
//                   {existingDocuments.map((doc) => (
//                     <Box key={doc.id} sx={{ display: 'flex', alignItems: 'center', p: 1, bgcolor: '#e8f5e8', borderRadius: 1, mb: 0.5 }}>
//                       <Typography variant="caption" sx={{ flexGrow: 1, mr: 1 }}>{doc.type}</Typography>
//                       <Box component="img" src={doc.url} sx={{ width: 30, height: 30, borderRadius: 1, mr: 1, objectFit: 'cover', backgroundColor: '#f0f0f0' }} />
//                       <span style={{ fontSize: '20px' }}>✓</span>
//                       {isEditMode && (
//                         <IconButton size="small" onClick={() => removeExistingDocument(doc.id)} sx={{ p: 0.2 }}>
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                       )}
//                     </Box>
//                   ))}
//                 </Box>
//               )}
              
//               <Box sx={{ position: 'relative', border: '2px dashed #1976d2', borderRadius: 2, p: 2, textAlign: 'center', cursor: 'pointer', backgroundColor: '#f8faff', '&:hover': { backgroundColor: '#e3f2fd' } }}>
//                 <input id="documents-upload" type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onChange={handleDocumentUpload} style={{ display: 'none' }} disabled={loading} />
//                 <label htmlFor="documents-upload">
//                   <Typography variant="body1" color="primary">
//                     ➕ {documents.length === 0 ? 'Upload New Documents' : `${documents.length} New Files`}
//                   </Typography>
//                 </label>
//               </Box>
              
//               {documents.length > 0 && (
//                 <Box sx={{ mt: 1, maxHeight: 120, overflow: 'auto' }}>
//                   {documents.map((file, index) => (
//                     <Box key={`new-${index}`} sx={{ display: 'flex', alignItems: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1, mb: 0.5 }}>
//                       <Typography variant="caption" sx={{ flexGrow: 1, mr: 1 }}>
//                         {file.name.length > 20 ? `${file.name.substring(0, 20)}...` : file.name}
//                       </Typography>
//                       <Typography variant="caption" color="textSecondary" sx={{ mr: 1 }}>
//                         {Math.round(file.size / 1024)}KB
//                       </Typography>
//                       <IconButton size="small" onClick={() => removeDocument(index)} sx={{ p: 0.2 }}>
//                         <CloseIcon fontSize="small" />
//                       </IconButton>
//                     </Box>
//                   ))}
//                 </Box>
//               )}
//             </Grid>
//           </Grid>

//           {/* 🔥 ALL FORM FIELDS - FIXED DISABLED LOGIC */}
//           <Grid item xs={12}>
//             <WSTextField 
//               control={control} 
//               id="Name" 
//               name="Name" 
//               rules={{ required: true }} 
//               label="Name *" 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSPhone 
//               label="Phone Number *" 
//               rules={{ required: true }} 
//               control={control} 
//               id="PhoneNumber" 
//               {...register("PhoneNumber")} 
//               name="PhoneNumber" 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSTextField 
//               control={control} 
//               id="FullAddress" 
//               name="FullAddress" 
//               rules={{ required: true }} 
//               label="Full Address *" 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSDateField 
//               id="DateOfBirth" 
//               name="DateOfBirth" 
//               label="Date of Birth *" 
//               dateFormat="DD-MM-YYYY" 
//               control={control} 
//               isInGridFilter={false} 
//               defaultValue="" 
//               rules={{ required: true }} 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSTextField 
//               control={control} 
//               id="Qualification" 
//               name="Qualification" 
//               rules={{ required: true }} 
//               label="Qualification *" 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSTextField 
//               control={control} 
//               id="Experience" 
//               name="Experience" 
//               rules={{ required: true }} 
//               label="Experience (Years) *" 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
          
//           <Grid item xs={12}>
//             <WSTextField 
//               control={control} 
//               id="WorkingHours" 
//               name="WorkingHours" 
//               rules={{ required: true }} 
//               label="Working Hours *" 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>

//           {/* Verification Fields */}
//           <Grid item xs={12}>
//             <Typography variant="h6" sx={{ mb: 2 }}>Documents & Verification</Typography>
//           </Grid>
//           <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Aadhar</Typography></Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.0")} 
//               id="aadhar" 
//               control={control} 
//               isInGridFilter={false} 
//               label="" 
//               name="Documents.0" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">License</Typography></Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.1")} 
//               id="license" 
//               control={control} 
//               label="" 
//               name="Documents.1" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Certification</Typography></Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.2")} 
//               id="certification" 
//               control={control} 
//               label="" 
//               name="Documents.2" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
//           <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Police Verification</Typography></Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField 
//               rules={{ required: true }} 
//               {...register("Documents.3")} 
//               id="policeVerification" 
//               control={control} 
//               label="" 
//               name="Documents.3" 
//               options={clientconfig.yesorno.staticOptionData} 
//               disabled={isFieldDisabled} 
//             />
//           </Grid>
//         </Grid>
//       </form>
//     </Grid>
//   );
// };

// export default TechnicianDrawer;




import { Divider, Grid, Typography, Box, IconButton, Alert } from "@mui/material";
import { useEffect, useState, useRef, useCallback } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
  useWatch,
} from "react-hook-form";
import http from "../../../commonFunctions/httpClient";
import { buildImageUrl, dateFormat, getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
import WSButton from "../../../Components/Button/WSButton";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSPhone from "../../../Components/Phone/WSPhone";
import WSDateField from "../../../Components/DateField/WSDateField";
import clientconfig from "../../../Config/clientConfig.json";
import config from "../../../Config/config.json";
import CloseIcon from '@mui/icons-material/Close';

interface ApiResponse {
  success?: boolean;
  message?: string;
  errors?: any;
  data?: any;
}

interface DocumentPreview {
  id: string;
  name: string;
  type: string;
  url: string;
  size: number;
}

interface PrescriptionProps {
  control?: Control<any>;
  errors?: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  noteId?: string;
  setValue: UseFormSetValue<any>;
  onCancel: () => void;
  onSuccess?: () => void;
}

const TechnicianDrawer: React.FC<PrescriptionProps> = ({
  control,
  id,
  register,
  reset,
  setValue,
  onCancel,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [vendorId, setVendorId] = useState("");
  const [documents, setDocuments] = useState<File[]>([]);
  const [existingDocuments, setExistingDocuments] = useState<DocumentPreview[]>([]);
  const [profileImagePreview, setProfileImagePreview] = useState<string | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [technicianId, setTechnicianId] = useState("");
  const [dataLoaded, setDataLoaded] = useState(true);
  // ✅ NEW: File validation states
  const [fileSizeError, setFileSizeError] = useState<string | null>(null);
  
  const profileImageRef = useRef<HTMLInputElement>(null);
  const hasLoadedRef = useRef(false);

  const formValues = useWatch({
    control,
  }) as any;

  // ✅ NEW: Validate file sizes (1MB = 1024 * 1024 bytes)
  const validateFileSizes = (): boolean => {
    const MAX_SIZE = 1024 * 1024; // 1MB
    
    // Check profile image
    const profileFile = profileImageRef.current?.files?.[0];
    if (profileFile && profileFile.size > MAX_SIZE) {
      setFileSizeError(`Profile image must be less than 1MB. Current size: ${(profileFile.size / 1024 / 1024).toFixed(2)}MB`);
      return false;
    }

    // Check documents
    for (const file of documents) {
      if (file.size > MAX_SIZE) {
        setFileSizeError(`Document "${file.name}" must be less than 1MB. Current size: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
        return false;
      }
    }
    
    return true;
  };

  // ✅ Get vendor ID
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setVendorId(userId || "");
  }, []);

  // 🔥 FIXED MAIN EFFECT: Proper ADD/EDIT logic
  useEffect(() => {
    const editMode = id && id.toString().startsWith("technicianEdit-");
    
    // 🔧 Reset ALL state when drawer opens
    setIsEditMode(editMode);
    setTechnicianId("");
    setExistingDocuments([]);
    setProfileImagePreview(null);
    setDocuments([]);
    setFileSizeError(null); // ✅ Clear errors
    
    // ✅ ADD mode: dataLoaded = true (fields ENABLED)
    // EDIT mode: dataLoaded = false (wait for load)
    setDataLoaded(!editMode);
    hasLoadedRef.current = false;
    
    if (editMode && control) {
      const techId = id.toString().replace("technicianEdit-", "");
      setTechnicianId(techId);
      loadTechnicianData(techId);
    }
  }, [id, control]);

  // 🔥 FIXED: Load data ONLY for EDIT mode
  const loadTechnicianData = useCallback(async (techId: string) => {
    if (hasLoadedRef.current || loading) return;
    
    try {
      hasLoadedRef.current = true;
      setLoading(true);
      console.log("📡 Fetching technician:", techId);
      
      const response: any = await http.get(`pharmacy/DeliveryPerson/${techId}`);

      const data = response?.data || response;

      if (reset) {
        reset({
          Name: "",
          PhoneNumber: "",
          FullAddress: "",
          DateOfBirth: "",
          Qualification: "",
          Experience: "",
          WorkingHours: "",
          "Documents.0": "no",
          "Documents.1": "no",
          "Documents.2": "no",
          "Documents.3": "no",
        });
      }

      if (setValue && data) {
        setValue("Name", data.name || "");
        setValue("PhoneNumber", data.phoneNumber || "");
        setValue("FullAddress", data.fullAddress || "");
        setValue("DateOfBirth", dateFormat(data?.dateOfBirth, "DD-MM-YYYY"));
        setValue("Qualification", data.qualification || "");
        setValue("Experience", data.experience?.toString() || "0");
        setValue("WorkingHours", data.workingHours || "");

        const boolToStr = (v: any) => (v === true || v === "true" ? "yes" : "no");
        setValue("Documents.0", boolToStr(data.isAadharVerified));
        setValue("Documents.1", boolToStr(data.isLicenseVerified));
        setValue("Documents.2", boolToStr(data.isCertificationVerified));
        setValue("Documents.3", boolToStr(data.isPoliceVerified));
      }

      // Profile image — try all common field names the API might return
      const profileImgPath =
        data.profileImageUrl ||
        data.profileImage ||
        data.profileImagePath ||
        data.profilePicture ||
        data.imageUrl ||
        data.image ||
        "";
      if (profileImgPath) {
        setProfileImagePreview(buildImageUrl(profileImgPath, config.imgUrl));
      } else {
        setProfileImagePreview(null);
      }

      // Documents — try multiple field names for the array and each doc's URL
      const rawDocs = data.documents || data.deliveryPersonDocuments || data.docs || [];
      if (Array.isArray(rawDocs) && rawDocs.length > 0) {
        const docPreviews: DocumentPreview[] = rawDocs.map((doc: any, index: number) => {
          const docUrl =
            doc.documentUrl ||
            doc.url ||
            doc.fileUrl ||
            doc.filePath ||
            doc.documentPath ||
            doc.imageUrl ||
            "";
          return {
            id: doc.id || String(index),
            name: doc.documentType
              ? `${doc.documentType.toLowerCase()}.pdf`
              : `document_${index + 1}.pdf`,
            type: doc.documentType || doc.type || "Document",
            url: docUrl ? buildImageUrl(docUrl, config.imgUrl) : "",
            size: 0,
          };
        });
        setExistingDocuments(docPreviews);
      } else {
        setExistingDocuments([]);
      }

      setDataLoaded(true);
    } catch (error: any) {
      console.error("💥 LOAD ERROR:", error);
    } finally {
      setLoading(false);
    }
  }, [setValue, reset]);

  const handleProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // ✅ Check file size on upload (1MB)
      if (file.size > 1024 * 1024) {
        setFileSizeError(`Profile image "${file.name}" must be less than 1MB. Current size: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
        e.target.value = '';
        return;
      }
      setFileSizeError(null);
      const previewUrl = URL.createObjectURL(file);
      setProfileImagePreview(previewUrl);
    }
  };

  const handleDocumentUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(e.target.files || []);
    
    // ✅ Check file sizes on upload
    for (const file of newFiles) {
      if (file.size > 1024 * 1024) {
        setFileSizeError(`Document "${file.name}" must be less than 1MB. Current size: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
        e.target.value = '';
        return;
      }
    }
    
    setFileSizeError(null);
    setDocuments(prev => [...prev, ...newFiles]);
    e.target.value = '';
  };

  const removeDocument = (indexToRemove: number) => {
    setDocuments(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const removeExistingDocument = (docId: string) => {
    setExistingDocuments(prev => prev.filter(doc => doc.id !== docId));
  };

  const handleProfileImageClick = () => {
    profileImageRef.current?.click();
  };

  const removeProfileImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    setProfileImagePreview(null);
    if (profileImageRef.current) {
      profileImageRef.current.value = '';
    }
  };

  // ✅ FIXED: Submit logic with file size validation
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // ✅ ADD mode: Always allow
    // EDIT mode: Wait for data
    if (loading || (isEditMode && !dataLoaded)) {
      console.log("⏳ Loading...");
      return;
    }
    
    // 🔥 NEW: Validate file sizes BEFORE submit
    if (!validateFileSizes()) {
      setLoading(false);
      return; // Stop submission and show error
    }
    
    setLoading(true);
    setFileSizeError(null); // Clear previous errors
    try {
      const formData = new FormData();
      
      const profileFile = profileImageRef.current?.files?.[0];
      if (profileFile) formData.append("ProfileImage", profileFile);
      
      formData.append("VendorId", vendorId);
      formData.append("Name", formValues?.Name || "");
      formData.append("PhoneNumber", formValues?.PhoneNumber || "");
      formData.append("FullAddress", formValues?.FullAddress || "");

      // Convert DD-MM-YYYY (stored by WSDateField) to ISO date-time required by API
      const rawDate = formValues?.DateOfBirth || "";
      let isoDate = "";
      if (rawDate) {
        const parts = rawDate.split("-");
        if (parts.length === 3 && parts[2]?.length === 4) {
          isoDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}T00:00:00.000Z`).toISOString();
        } else {
          isoDate = rawDate;
        }
      }
      formData.append("DateOfBirth", isoDate);

      formData.append("Qualification", formValues?.Qualification || "");
      formData.append("Experience", String(parseInt(formValues?.Experience || "0", 10) || 0));
      formData.append("WorkingHours", formValues?.WorkingHours || "");

      documents.forEach((file) => formData.append("Documents", file));

      const documentTypes = ["Aadhar", "License", "Certification", "Police"];
      documentTypes.forEach(type => formData.append("DocumentTypes", type));

      // Verification flags — backend expects these; without them the dropdowns never persist
      const strToBool = (v: any) => (v === "yes" || v === "true" || v === true ? "true" : "false");
      formData.append("IsAadharVerified", strToBool(formValues?.["Documents.0"]));
      formData.append("IsLicenseVerified", strToBool(formValues?.["Documents.1"]));
      formData.append("IsCertificationVerified", strToBool(formValues?.["Documents.2"]));
      formData.append("IsPoliceVerified", strToBool(formValues?.["Documents.3"]));

      let response: any;
      if (isEditMode && technicianId) {
        response = await http.putFormData(`pharmacy/DeliveryPerson/${technicianId}`, formData);
      } else {
        response = await http.postFormData(`pharmacy/DeliveryPerson`, formData);
      }

      // putFormData/postFormData swallow HTTP errors and return the error body,
      // so we must verify success here instead of relying on the catch block.
      // This endpoint returns the saved entity (with an `id`) on success rather
      // than a { success: true } wrapper, so accept either shape.
      const isSuccess =
        response?.success === true ||
        (!!response?.id && response?.success !== false && !response?.errors);
      if (!isSuccess) {
        const errMsg =
          response?.message ||
          (response?.errors ? JSON.stringify(response.errors) : null) ||
          (isEditMode ? "Failed to update technician" : "Failed to create technician");
        console.error("❌ Save failed:", response);
        alert(errMsg);
        return;
      }

      const message = response?.message || (isEditMode ? "Delivery person updated!" : "Delivery person created!");
      alert(message);
      setDocuments([]);
      setProfileImagePreview(null);
      setExistingDocuments([]);
      if (profileImageRef.current) profileImageRef.current.value = "";
      if (reset) reset();
      onCancel();
      onSuccess?.();
    } catch (error: any) {
      console.error("💥 ERROR:", error);
      alert(error?.response?.data?.message || "Failed to save technician");
    } finally {
      setLoading(false);
    }
  };

  // 🔥 CRITICAL: FIXED DISABLED LOGIC
  const isFieldDisabled = loading || (isEditMode && !dataLoaded);

  useEffect(() => {
    return () => {
      if (profileImagePreview && !profileImagePreview.startsWith(config.imgUrl)) {
        URL.revokeObjectURL(profileImagePreview);
      }
    };
  }, [profileImagePreview]);

  return (
    <Grid>
      <form id={id} onSubmit={handleSubmit}>
        <Grid container spacing={2} mt={2}>
          {/* 🔥 NEW: File Size Error Display */}
          {fileSizeError && (
            <Grid item xs={12}>
              <Alert severity="error" sx={{ mb: 2 }}>
                {fileSizeError}
              </Alert>
            </Grid>
          )}
          
          {/* Profile + Documents */}
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ position: 'relative', height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box sx={{
                  border: '3px dashed #1976d2',
                  borderRadius: '50%',
                  width: 160,
                  height: 160,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#f8faff',
                  cursor: 'pointer',
                  position: 'relative',
                  '&:hover': { 
                    backgroundColor: profileImagePreview ? '#e3f2fd' : '#e3f2fd', 
                    borderColor: '#1565c0' 
                  }
                }} onClick={handleProfileImageClick}>
                  {profileImagePreview ? (
                    <>
                      <Box sx={{ width: '80%', height: "80%", borderRadius: '50%', overflow: 'hidden', position: 'relative' }}>
                        <img 
                          src={profileImagePreview} 
                          alt="Profile preview" 
                          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: '50%' }} 
                        />
                      </Box>
                      <IconButton onClick={removeProfileImage} sx={{ position: 'absolute', top: -8, right: -8, backgroundColor: 'rgba(0,0,0,0.8)', color: 'white', width: 32, height: 32, minWidth: 0, '&:hover': { backgroundColor: 'rgba(0,0,0,1)' } }} size="small">
                        <CloseIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <Box sx={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#e3f2fd', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}></Box>
                      <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', px: 1 }}>Click to upload</Typography>
                      <Typography variant="caption" color="textSecondary">(JPG, PNG <strong>&lt; 1MB</strong>)</Typography>
                    </>
                  )}
                </Box>
                <input
                  ref={profileImageRef}
                  type="file"
                  name="ProfileImage"
                  accept="image/*"
                  style={{ display: 'none' }}
                  disabled={loading}
                  onChange={handleProfileImageChange}
                />
              </Box>
            </Grid>

            {/* Documents Section */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                📎 Documents ({existingDocuments.length + documents.length})
              </Typography>
              
              {existingDocuments.length > 0 && (
                <Box sx={{ mb: 2 }}>
                 <Typography variant="caption" color="success.main" sx={{ fontWeight: 500 }}>
                   Existing ({existingDocuments.length})
                 </Typography>
                 {existingDocuments.map((doc) => (
                   <Box key={doc.id} sx={{ display: 'flex', alignItems: 'center', p: 1, bgcolor: '#e8f5e8', borderRadius: 1, mb: 0.5 }}>
                     <Typography variant="caption" sx={{ flexGrow: 1, mr: 1 }}>{doc.type}</Typography>
                     <Box component="img" src={doc.url} sx={{ width: 30, height: 30, borderRadius: 1, mr: 1, objectFit: 'cover', backgroundColor: '#f0f0f0' }} />
                     <span style={{ fontSize: '20px' }}>✓</span>
                     {isEditMode && (
                       <IconButton size="small" onClick={() => removeExistingDocument(doc.id)} sx={{ p: 0.2 }}>
                         <CloseIcon fontSize="small" />
                       </IconButton>
                     )}
                   </Box>
                 ))}
                </Box>
              )}
              
              <Box sx={{ position: 'relative', border: '2px dashed #1976d2', borderRadius: 2, p: 2, textAlign: 'center', cursor: 'pointer', backgroundColor: '#f8faff', '&:hover': { backgroundColor: '#e3f2fd' } }}>
                <input id="documents-upload" type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onChange={handleDocumentUpload} style={{ display: 'none' }} disabled={loading} />
                <label htmlFor="documents-upload">
                  <Typography variant="body1" color="primary">
                    ➕ {documents.length === 0 ? 'Upload New Documents ' : `${documents.length} New Files`}
                  </Typography>
                </label>
              </Box>
              
              {documents.length > 0 && (
                <Box sx={{ mt: 1, maxHeight: 120, overflow: 'auto' }}>
                 {documents.map((file, index) => (
                   <Box key={`new-${index}`} sx={{ display: 'flex', alignItems: 'center', p: 1, bgcolor: '#e3f2fd', borderRadius: 1, mb: 0.5 }}>
                     <Typography variant="caption" sx={{ flexGrow: 1, mr: 1 }}>
                       {file.name.length > 20 ? `${file.name.substring(0, 20)}...` : file.name}
                     </Typography>
                     <Typography variant="caption" color="textSecondary" sx={{ mr: 1 }}>
                       {Math.round(file.size / 1024)}KB
                     </Typography>
                     <IconButton size="small" onClick={() => removeDocument(index)} sx={{ p: 0.2 }}>
                       <CloseIcon fontSize="small" />
                     </IconButton>
                   </Box>
                 ))}
                </Box>
              )}
            </Grid>
          </Grid>

          {/* 🔥 ALL FORM FIELDS - FIXED DISABLED LOGIC */}
          <Grid item xs={12}>
            <WSTextField 
              control={control} 
              id="Name" 
              name="Name" 
              rules={{ required: true }} 
              label="Name *" 
              disabled={isFieldDisabled} 
            />
          </Grid>
          
          <Grid item xs={12}>
            <WSPhone 
              label="Phone Number *" 
              rules={{ required: true }} 
              control={control} 
              id="PhoneNumber" 
              {...register("PhoneNumber")} 
              name="PhoneNumber" 
              disabled={isFieldDisabled} 
            />
          </Grid>
          
          <Grid item xs={12}>
            <WSTextField 
              control={control} 
              id="FullAddress" 
              name="FullAddress" 
              rules={{ required: true }} 
              label="Full Address *" 
              disabled={isFieldDisabled} 
            />
          </Grid>
          
          <Grid item xs={12}>
            <WSDateField 
              id="DateOfBirth" 
              name="DateOfBirth" 
              label="Date of Birth *" 
              dateFormat="DD-MM-YYYY" 
              control={control} 
              isInGridFilter={false} 
              defaultValue="" 
              rules={{ required: true }} 
              disabled={isFieldDisabled} 
            />
          </Grid>
          
          <Grid item xs={12}>
            <WSTextField 
              control={control} 
              id="Qualification" 
              name="Qualification" 
              rules={{ required: true }} 
              label="Qualification *" 
              disabled={isFieldDisabled} 
            />
          </Grid>
          
          <Grid item xs={12}>
            <WSTextField 
              control={control} 
              id="Experience" 
              name="Experience" 
              rules={{ required: true }} 
              label="Experience (Years) *" 
              disabled={isFieldDisabled} 
            />
          </Grid>
          
          <Grid item xs={12}>
            <WSTextField 
              control={control} 
              id="WorkingHours" 
              name="WorkingHours" 
              rules={{ required: true }} 
              label="Working Hours *" 
              disabled={isFieldDisabled} 
            />
          </Grid>

          {/* Verification Fields */}
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 2 }}>Documents & Verification</Typography>
          </Grid>
          <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Aadhar</Typography></Grid>
          <Grid item xs={12} sm={2}>
            <WSSelectField 
              rules={{ required: true }} 
              {...register("Documents.0")} 
              id="aadhar" 
              control={control} 
              isInGridFilter={false} 
              label="" 
              name="Documents.0" 
              options={clientconfig.yesorno.staticOptionData} 
              disabled={isFieldDisabled} 
            />
          </Grid>
          <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">License</Typography></Grid>
          <Grid item xs={12} sm={2}>
            <WSSelectField 
              rules={{ required: true }} 
              {...register("Documents.1")} 
              id="license" 
              control={control} 
              label="" 
              name="Documents.1" 
              options={clientconfig.yesorno.staticOptionData} 
              disabled={isFieldDisabled} 
            />
          </Grid>
          <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Certification</Typography></Grid>
          <Grid item xs={12} sm={2}>
            <WSSelectField 
              rules={{ required: true }} 
              {...register("Documents.2")} 
              id="certification" 
              control={control} 
              label="" 
              name="Documents.2" 
              options={clientconfig.yesorno.staticOptionData} 
              disabled={isFieldDisabled} 
            />
          </Grid>
          <Grid item xs={12} sm={10}><Typography variant="body2" color="GrayText">Police Verification</Typography></Grid>
          <Grid item xs={12} sm={2}>
            <WSSelectField 
              rules={{ required: true }} 
              {...register("Documents.3")} 
              id="policeVerification" 
              control={control} 
              label="" 
              name="Documents.3" 
              options={clientconfig.yesorno.staticOptionData} 
              disabled={isFieldDisabled} 
            />
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};

export default TechnicianDrawer;
